/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SortingOrder {
    ASC = 'asc',
    DESC = 'desc',
}
